import {
    StyledLabelProps,
} from "./styles";
import GemIcon from "../GemIcon";
import { Container, ContainerProps, StyledLabelP } from "modules/Sty";
import useBrand from 'Hooks/useBrand';
import { PlanType } from "modules/Const";
import { clsx } from "modules/Utils";
import CustomAvatar from "components/ProfileDropdown/CustomAvatar";

interface AvatarUserStatusProps {
    className: string;
    isWhiteBorder?: boolean;
    styles?: ContainerProps;
    proStatusStyles?: ContainerProps;
    userNameTextStyles?: StyledLabelProps;
    proTextStyles?: StyledLabelProps;
    userContainerStyles?: ContainerProps;
    isSmallSidebar?: boolean;
    imageOverride?: string;
    isCursorPointer?: boolean;
}

const AvatarUserStatus = ({
    className,
    isWhiteBorder = false,
    styles,
    proStatusStyles,
    userNameTextStyles,
    proTextStyles,
    userContainerStyles,
    isSmallSidebar,
    imageOverride = '',
    isCursorPointer = false,
}: AvatarUserStatusProps) => {
    const { currentBrand, getBrandImage } = useBrand()

    if (!currentBrand) {
        return null
    }

    const { name: brandName } = currentBrand

    const avatar = imageOverride || getBrandImage() || ''

    const renderAccountStatus = () => {
        if (!currentBrand.tier) {
            return null
        }

        const tier = currentBrand.tier

        let text = ''
        let icon = null
        switch (tier) {
            case PlanType.TEAM:
                text = 'TEAM ACCOUNT'
                icon = <GemIcon />
                break
            case PlanType.PRO:
                text = 'PRO ACCOUNT'
                icon = <GemIcon />
                break
            case PlanType.LITE:
                text = 'LITE ACCOUNT'
                icon = <GemIcon />
                break
            default:
                text = ''
        }

        return (
            <Container className="avatarUserStatus" alignItems="center" {...proStatusStyles} display="flex">
                {icon}
                <StyledLabelP {...proTextStyles}>
                    {text}
                </StyledLabelP>
            </Container>
        );
    };

    return (
        <Container
            className={clsx('avatarUserStatusContainer', className)}
            {...styles}
            display="flex"
            alignItems="center"
            cursor={isCursorPointer ? 'pointer' : 'default'}
        >
            <CustomAvatar
                className="avatarUserStatusAvatar"
                brandOverride={currentBrand}
                image={avatar}
                isBorder
            />
            <Container
                className="avatarUserStatusUserContainer"
                {...userContainerStyles}
                cursor={isCursorPointer ? 'pointer' : 'default'}
                display={isSmallSidebar ? 'none' : 'flex'}
                flexDirection="column"
                alignItems="flex-start"
            >
                <StyledLabelP
                    className="avatarUserStatusUserName"
                    {...userNameTextStyles}
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    {brandName}
                </StyledLabelP>
                {/* NOTE: uncomment this if you want to see the brand id in the dropdown */}
                {/* <div className="brandIdForAdmin">{currentBrand.id}</div> */}
                {renderAccountStatus()}
            </Container>
        </Container>
    )
}

export default AvatarUserStatus
